import classNames from 'classnames'
import css from './InfoWithIcon.styles.scss'

interface InfoWithIconProps {
  icon: React.ReactElement
  emphasizedText: string
  restOfText?: string
}

export const InfoWithIcon = ({
  icon,
  emphasizedText,
  restOfText,
}: InfoWithIconProps) => (
  <div className={css.InfoWithIcon}>
    <div className={css.InfoWithIcon__icons}>{icon}</div>
    <div className={css.InfoWithIcon__container}>
      <span
        className={classNames(css.InfoWithIcon, [
          css[`InfoWithIcon--emphasized`],
        ])}
      >
        {emphasizedText}&nbsp;
      </span>
      <span>{restOfText}</span>
    </div>
  </div>
)
